import Styles from './LinkedinPost.module.scss'
import { Skin } from '../Skin'
import { SkinProps } from '../Types'

const LinkedinPost = ({ children, maxCharacterCount }: SkinProps) => {
  return (
    <Skin.Root className={Styles.linkedinPost} data-testid="linkedin-frame-skin">
      <Skin.CaptionAbove lines={3} maxCharacterCount={maxCharacterCount} />
      {children}
    </Skin.Root>
  )
}

export { LinkedinPost }
